import { render, staticRenderFns } from "./ErrorPoint.vue?vue&type=template&id=893dfab2&scoped=true&"
import script from "./ErrorPoint.vue?vue&type=script&lang=js&"
export * from "./ErrorPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "893dfab2",
  null
  
)

export default component.exports